import { DETAIL_GET, DETAIL_RESET } from "./mutation-types";

export default {
  [DETAIL_GET](state, data) {
    state.dataOrder = data.dataOrder;
    state.dataEquipment = data.arr;
    state.exist = data.exist;
  },
  [DETAIL_RESET](state) {
    state.data = {};
    state.exist = false;
  }
};
